import { Link } from "react-router-dom";
import { ArrowRight, Rocket } from "lucide-react";
import { GETTING_STARTED_STEPS } from "./documentationOverviewContent";
import {
  SECTION_EYEBROW,
  SECTION_SPACING,
  SECTION_SUBTITLE,
  SECTION_TITLE,
} from "./overviewTokens";

export function GettingStartedSection() {
  return (
    <section aria-labelledby="doc-getting-started" className={SECTION_SPACING} id="getting-started">
      <div className="flex items-start gap-4">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
          <Rocket className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <p className={SECTION_EYEBROW}>For new libraries</p>
          <h2 id="doc-getting-started" className={SECTION_TITLE}>
            Get PhiloLMS running in 5 steps
          </h2>
          <p className={SECTION_SUBTITLE}>
            A recommended order for brand-new tenants. You can skip steps you've already done —
            everything is available from the sidebar too.
          </p>
        </div>
      </div>

      <ol className="mt-6 space-y-3">
        {GETTING_STARTED_STEPS.map((step) => (
          <li
            key={step.number}
            className="group flex items-start gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-xs transition-all duration-300 ease-out hover:border-primary/30 hover:shadow-md"
          >
            <div
              className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 font-heading text-sm font-bold text-primary transition-transform duration-300 ease-out group-hover:scale-110"
              aria-hidden
            >
              {step.number}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading text-base font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">{step.description}</p>
              {step.link && (
                <Link
                  to={step.link.to}
                  className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-primary transition-transform duration-200 ease-out hover:gap-1.5"
                >
                  {step.link.label}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}
